module.exports = __webpack_public_path__ + "img/LL-old.6c565177.png";